import 'moment-precise-range-plugin'
import moment from 'moment'

export const calculateDateGap = (dt) => moment.preciseDiff(moment(dt), moment(), true)
export const padNumber = (num) => `${num<10 ? '0' : ''}${num}`